var render = function render(){var _vm=this,_c=_vm._self._c;return _c('window',{attrs:{"title":"Basic"}},[_c('vue-chart',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }